import $ from 'jquery'

$('#js-adviser-popup-banner-close').click(() => {
  $('#js-adviser-popup-banner').remove()
})
